{
    "ErrorMessage": "Não foi possível carregar o ficheiro de áudio.",
    "NAME": "MediaPlayer"
}